/**
 *
 * AssignmentRejectedTag
 *
 */

import React, { memo } from 'react';
import styled from 'styled-components';

import PinTripIcon from 'assets/v2/PinTripIcon';
import { COLORS } from 'theme';
import Tag from '..';

const StyledTag = styled(Tag)`
  &.MuiChip-root {
    color: ${COLORS.orchidDark};
    background: ${COLORS.orchidLight};
    border-color: ${COLORS.orchid};
    border-radius: ${({ theme }) => theme.borderRadius.secondary};

    &&& .MuiChip-icon path {
      fill: ${COLORS.orchid};
    }
  }
`;

function AssignmentRejectedTag(props) {
  return (
    <StyledTag label="Assignment Rejected" icon={<PinTripIcon />} {...props} />
  );
}

export default memo(AssignmentRejectedTag);
